import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { SoaDocumentStatus, StudentOnlineApplicationStatus } from '@modules/types/graphql';
import { SoaDocumentEntityList } from './soa-document.entity-list';

import type { StudentOnlineApplication } from '@modules/types/graphql';
import type { SoaDocumentEntity } from './soa-document.entity';

export type Entity = Partial<StudentOnlineApplication> | null;

@DecribeEntity('StudentOnlineApplicationEntity')
class StudentOnlineApplicationEntity extends BaseEntity {
    id: string;
    status: StudentOnlineApplicationStatus;
    active: boolean;
    documentsZipUrl: string;

    @RelationList(() => SoaDocumentEntityList)
    documents: SoaDocumentEntity[];

    constructor(entity: Entity) {
        super(entity);

        this.id = entity?.id ?? '';
        this.status = entity?.status ?? StudentOnlineApplicationStatus.empty;
        this.active = entity?.active ?? false;
        this.documentsZipUrl = entity?.documentsZipUrl ?? '';
    }

    isActive() {
        return this.active && this.status !== StudentOnlineApplicationStatus.empty;
    }

    getReviewDocumentsCount() {
        const result = this.documents.reduce((carry, document) => {
            if (document.status === SoaDocumentStatus.review) {
                carry += 1;
            }

            return carry;
        }, 0);

        return result;
    }

    waitForSchoolReview() {
        const hasDocumentToReview = this.documents.some(
            document => document.status === SoaDocumentStatus.review,
        );

        return hasDocumentToReview;
    }

    groupDocumentsByStatus() {
        const map = this.documents.reduce((carry, document) => {
            if (!this.isActive()) {
                return carry;
            }

            if (typeof carry[document.status] === 'undefined') {
                carry[document.status] = 0;
            }

            carry[document.status]++;

            return carry;
        }, {} as Record<SoaDocumentStatus, number>);

        const result = Object.entries(map);

        result.sort(([, aCount], [, bCount]) => (aCount > bCount ? -1 : 1));

        return result;
    }
}

export { StudentOnlineApplicationEntity };
